module.exports = __webpack_public_path__ + "static/media/rospatent.a6cf394d.png";